// 별자리 계산 함수
export function calculateZodiacSign(birthDate: string): string {
  const date = new Date(birthDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();

  if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return '양자리';
  if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return '황소자리';
  if ((month === 5 && day >= 21) || (month === 6 && day <= 21)) return '쌍둥이자리';
  if ((month === 6 && day >= 22) || (month === 7 && day <= 22)) return '게자리';
  if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return '사자자리';
  if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return '처녀자리';
  if ((month === 9 && day >= 23) || (month === 10 && day <= 23)) return '천칭자리';
  if ((month === 10 && day >= 24) || (month === 11 && day <= 22)) return '전갈자리';
  if ((month === 11 && day >= 23) || (month === 12 && day <= 21)) return '사수자리';
  if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return '염소자리';
  if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return '물병자리';
  return '물고기자리';
}

// 별자리 영문명
export function getZodiacEnglishName(koreanName: string): string {
  const zodiacMap: Record<string, string> = {
    '양자리': 'Aries',
    '황소자리': 'Taurus',
    '쌍둥이자리': 'Gemini',
    '게자리': 'Cancer',
    '사자자리': 'Leo',
    '처녀자리': 'Virgo',
    '천칭자리': 'Libra',
    '전갈자리': 'Scorpio',
    '사수자리': 'Sagittarius',
    '염소자리': 'Capricorn',
    '물병자리': 'Aquarius',
    '물고기자리': 'Pisces'
  };
  return zodiacMap[koreanName] || koreanName;
}

// 별자리 특성
export function getZodiacTraits(zodiacSign: string): { element: string; quality: string; ruler: string } {
  const traits: Record<string, { element: string; quality: string; ruler: string }> = {
    '양자리': { element: '불', quality: '활동궁', ruler: '화성' },
    '황소자리': { element: '흙', quality: '고정궁', ruler: '금성' },
    '쌍둥이자리': { element: '공기', quality: '변동궁', ruler: '수성' },
    '게자리': { element: '물', quality: '활동궁', ruler: '달' },
    '사자자리': { element: '불', quality: '고정궁', ruler: '태양' },
    '처녀자리': { element: '흙', quality: '변동궁', ruler: '수성' },
    '천칭자리': { element: '공기', quality: '활동궁', ruler: '금성' },
    '전갈자리': { element: '물', quality: '고정궁', ruler: '명왕성' },
    '사수자리': { element: '불', quality: '변동궁', ruler: '목성' },
    '염소자리': { element: '흙', quality: '활동궁', ruler: '토성' },
    '물병자리': { element: '공기', quality: '고정궁', ruler: '천왕성' },
    '물고기자리': { element: '물', quality: '변동궁', ruler: '해왕성' }
  };
  return traits[zodiacSign] || { element: '알 수 없음', quality: '알 수 없음', ruler: '알 수 없음' };
}